<template>
    <div class="Traffic">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="select_box">
            <div style="width: 100px;">
                <el-select v-model="dateOptionValue" placeholder="自然天">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div v-show="dateOptionValue === 1">
                <el-date-picker :clearable="false" v-model="dateValue" align="left" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 2">
                <el-date-picker :clearable="false" v-model="dateValue" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周" :picker-options="disabledDatePickerOptions"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 3">
                <el-date-picker :clearable="false" v-model="dateValue" align="left" type="month" placeholder="选择月" :picker-options="disabledDatePickerOptions"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 4">
                <el-date-picker
                    :picker-options="disabledDatePickerOptions"
                    :clearable="false"
                    format="yyyy-MM-dd"
                    v-model="periodTime"
                    align="left"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <el-button type="primary" @click="searchClick" plain>搜索</el-button>
        </div>
        <div class='content_container bgc box-shadow'>
            <div class="title_box">
                <p>流量趋势</p>
                <p @click="exportClick"><img :src="icon" alt="">导出</p>
            </div>
            <el-dialog title="导出流量趋势数据" :visible.sync="exportTips">
                <div class="export_box">
                    <div>
                        <span>时间粒度</span>
                        <div style="width: 100px;">
                            <el-select v-model="exportDateOptionValue" placeholder="自然天">
                                <el-option v-for="item in exportDateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div>
                        <span>导出范围</span>
                        <div>
                            <el-date-picker v-model="exportDateValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </div>
                    </div>
                    <div>
                        <span>office版本</span>
                        <div>
                            <el-radio-group v-model="radio2">
                                <el-radio :label="3">非office2003</el-radio>
                                <el-radio :label="6">office2003</el-radio>
                            </el-radio-group>
                            <p>如果下载文件出现乱码，请选择另一个office版本选项进行下载</p>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="exportTips = false">取 消</el-button>
                    <el-button type="primary" @click="sureExport()">导 出</el-button>
                </div>
            </el-dialog>
            <div class="access_box">
                <div class="access_item" v-for="(item, index) of accessData" :key="index">
                    <p>
                        <span>{{item.title}}</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">{{item.toolText}}</div>
                            <img class="tooltip_icon" :src="item.icon" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{item.number}}</p>
                    <p>较前一天 {{item.beforeDay}}</p>
                </div>
            </div>
            <div class="echarts_line_box">
                <TrafficEchartsLine :echartsLineData="echartsLineData"></TrafficEchartsLine>
            </div>
            <div class="table_box">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="datetime" label="时间"></el-table-column>
                    <el-table-column prop="shopvisitUser" label="店铺访问量(PV)" align='center'></el-table-column>
                    <el-table-column prop="shopvisit" label="店铺访客数(UV)" align='center'></el-table-column>
                    <el-table-column prop="goodsvisit" label="商品访访问量" align='center'></el-table-column>
                    <el-table-column prop="goodvisitUser" label="商品访客数" align='center'></el-table-column>
                </el-table>
                <page :total="total" ref="page" @getList="getPageData"></page>
            </div>
        </div>
    </div>
</template>

<script>
import TrafficEchartsLine from 'views/dataCenter/dataTabs/echarts/TrafficEchartsLine'
import Page from 'base/page/page'
import {getTrafficTrends, getTrafficAnalysis, trafficExport} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'Traffic',
    data() {
        return {
            activeIndex: '2',
            exportDateOptionValue: '自然天',
            exportDateOptions: [
                {
                    value: 1,
                    label: '自然天'
                }
            ],
            exportDateValue: '',
            radio2: 3,
            total: 0,
            icon: require('@/common/images/other/data_center_report_icon@2x.png'),
            echartsLineData: [],
            accessData: [
                {title: '店铺访客数（UV）', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: `筛选时间内，店铺所有页面的访问人数;按自然天、周、月查看时：同一用户多次访问会进行去重;按自定义时间范围查看时：同一用户多次访问单日内会去重，多日累加`, number: 0, beforeDay: '0.00%'},
                {title: '店铺访问量（PV）', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '店铺浏览量：筛选时间内，店铺所有页面被访问的次数，一个人在筛选时间内访问多次记为多次', number: 0, beforeDay: '0.00%'},
                {title: '商品访客数', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '筛选时间内，商品页面的访问人数;按自然天、周、月查看时：同一用户多次访问会进行去重;按自定义时间范围查看时：同一用户多次访问单日内会去重，多日累加；', number: 0, beforeDay: '0.00%'},
                {title: '商品访问量', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '商品浏览量：筛选时间内，商品详情页被访问的次数，一个人在筛选时间内访问多次记为多次', number: 0, beforeDay: '0.00%'}
            ],
            options: [
                {
                    value: 1,
                    label: '自然天'
                },
                {
                    value: 2,
                    label: '自然周'
                },
                {
                    value: 3,
                    label: '自然月'
                },
                {
                    value: 4,
                    label: '自定义'
                }
            ],
            dateOptionValue: 1,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [{
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        picker.$emit('pick', date)
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', date)
                    }
                }]
            },
            disabledDatePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                }
            },
            dateValue: '',
            periodTime: '',
            tableData: [],
            exportTips: false
        }
    },
    mounted() {
        this.findTrafficTrends()
        this.findTrafficAnalysis()
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        getWeek(value) {
            // 按周日为一周的最后一天计算
            var date = value
            // 今天是这周的第几天
            var today = date.getDay()
            // 上周日距离今天的天数（负数表示）
            var stepSunDay = -today + 1
            // 如果今天是周日
            if (today === 0) {
                stepSunDay = -7
            }
            // 周一距离今天的天数（负数表示）
            var stepMonday = 7 - today
            var time = date.getTime()
            var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
            var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
            // 本周一的日期 （起始日期）
            var startDate = this.transferDate(monday) // 日期变换
            // 本周日的日期 （结束日期）
            var endDate = this.transferDate(sunday) // 日期变换
            return [startDate, endDate]
        },
        getMonth(value) {
            // 获取当前月的第一天
            var start = value
            start.setDate(1)
            // 获取当前月的最后一天
            var date = value
            var currentMonth = date.getMonth()
            var nextMonth = ++currentMonth
            var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
            var oneDay = 1000 * 60 * 60 * 24
            var end = new Date(nextMonthFirstDay - oneDay)
            var startDate = this.transferDate(start) // 日期变换
            var endDate = this.transferDate(end) // 日期变换
            return [startDate, endDate]
        },
        transferDate(date) {
            // 年
            var year = date.getFullYear()
            // 月
            var month = date.getMonth() + 1
            // 日
            var day = date.getDate()
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            var dateString = year + '-' + month + '-' + day
            return dateString
        },
        // 导出
        exportClick() {
            // this.exportTips = true
            if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.dateOptionValue === 1) {
                params = {
                    beginTime: this.transferDate(this.dateValue),
                    endTime: this.transferDate(this.dateValue)
                }
            } else if (this.dateOptionValue === 2) {
                params = {
                    beginTime: this.getWeek(this.dateValue)[0],
                    endTime: this.getWeek(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 3) {
                params = {
                    beginTime: this.getMonth(this.dateValue)[0],
                    endTime: this.getMonth(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 4) {
                params = {
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            trafficExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '流量趋势' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 确定导出--未使用
        sureExport() {
            console.log(this.exportDateValue)
            console.log(this.transferDate(this.exportDateValue[0]))
            console.log(this.transferDate(this.exportDateValue[1]))
            console.log(this.getWeek(this.exportDateValue[0]))
            console.log(this.getMonth(this.exportDateValue[0]))
        },
        searchClick() {
            if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            this.getTrafficData()
            this.handleQuery()
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        getTrafficData() {
            this.setLoading(true)
            var params = {
                timeFormat: this.dateOptionValue === '自然天' ? 1 : this.dateOptionValue,
                beginTime: this.transferDate(this.dateValue)
            }
            if (this.dateOptionValue === 4) {
                params = {
                    timeFormat: this.dateOptionValue === '自然天' ? 1 : this.dateOptionValue,
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            getTrafficTrends({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.echartsLineData = data.data
                    this.accessData[0].number = data.data[1].shopVisitClient
                    this.accessData[0].beforeDay = data.data[1].shopvisitclientgrowthrate
                    this.accessData[1].number = data.data[2].shopConentView
                    this.accessData[1].beforeDay = data.data[2].shopconentviewgrowthrate
                    this.accessData[2].number = data.data[3].goodsVisitClient
                    this.accessData[2].beforeDay = data.data[3].goodsvisitclientgrowthrate
                    this.accessData[3].number = data.data[4].goodsConentView
                    this.accessData[3].beforeDay = data.data[4].goodsconentviewgrowthrate
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        getPageData() {
            this.setLoading(true)
            var params = {
                timeFormat: this.dateOptionValue === '自然天' ? 1 : this.dateOptionValue,
                beginTime: this.dateValue === '' ? this.getDateTime(0) : this.transferDate(this.dateValue)
            }
            if (this.dateOptionValue === 4) {
                params = {
                    timeFormat: this.dateOptionValue === '自然天' ? 1 : this.dateOptionValue,
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            getTrafficAnalysis({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.splitPage.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--流量趋势
        findTrafficTrends() {
            this.setLoading(true)
            var params = {
                timeFormat: 1,
                beginTime: this.getDateTime(0)
            }
            getTrafficTrends({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.echartsLineData = data.data
                    this.accessData[0].number = data.data[1].shopVisitClient
                    this.accessData[0].beforeDay = data.data[1].shopvisitclientgrowthrate
                    this.accessData[1].number = data.data[2].shopConentView
                    this.accessData[1].beforeDay = data.data[2].shopconentviewgrowthrate
                    this.accessData[2].number = data.data[3].goodsVisitClient
                    this.accessData[2].beforeDay = data.data[3].goodsvisitclientgrowthrate
                    this.accessData[3].number = data.data[4].goodsConentView
                    this.accessData[3].beforeDay = data.data[4].goodsconentviewgrowthrate
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--流量趋势表格数据
        findTrafficAnalysis() {
            this.setLoading(true)
            var params = {
                timeFormat: 1,
                beginTime: this.getDateTime(0)
            }
            getTrafficAnalysis({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.splitPage.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        // 获取本月/上一个月 自然天前上一周日期
        getDateMonthTime(type) {
            var time = (new Date()).getTime() - 7 * 24 * 60 * 60 * 1000
            var dateTime = new Date(time)
            var year = dateTime.getFullYear()
            var month = null
            if (type === 1) {
                month = dateTime.getMonth() + 1
            }
            if (type === 0) {
                month = dateTime.getMonth()
            }
            if (month === 0) {
                month = 12
                year = year - 1
            }
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        TrafficEchartsLine,
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Traffic {
    .select_box{
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
        &>div {
            margin-right: 20px;
            .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                width: 240px;
            }
            .el-date-editor .el-range-separator {
                line-height: 28px;
            }
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 0;
            height: 36px;
        }
        .el-button {
            height: 36px;
        }
    }
    .content_container{
        // box-shadow:2px 0px 6px 0px rgba(0,21,41,0.14);
        padding: 15px;
        padding-bottom: 50px;
        .title_box{
            height: 50px;
            background-color: #F5F7FA;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 15px;
            margin-bottom: 20px;
            p {
                height:16px;
                line-height:16px;
            }
            &>p:nth-of-type(1) {
                border-left: 2px solid #409EFF;
                padding-left: 10px;
            }
            &>p:nth-of-type(2) {
                color: #409EFF;
                display: flex;
                align-items: center;
                cursor: pointer;
                img{
                    width: 16px;
                    height: 14px;
                    margin-right: 8px;
                }
            }
        }
        .access_box{
            display: flex;
            .access_item{
                width: 25%;
                height: 138px;
                box-sizing: border-box;
                padding: 20px;
                color: #606266;
                border: 1px solid #DCDFE6;
                border-right: none;
                p:nth-of-type(1) {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                    }
                }
                p:nth-of-type(2) {
                    font-size:28px;
                    height:40px;
                    line-height:40px;
                    margin: 10px 0;
                }
                p:nth-of-type(3), p:nth-of-type(1) {
                    height: 20px;
                    line-height:20px;
                }
            }
            .access_item:nth-last-of-type(1) {
                border-right: 1px solid #DCDFE6;
            }
        }
        .echarts_line_box {
            margin-top: 20px;
            margin-bottom: 60px;
            height: 400px;
        }
        .table_box{
            .el-table th>.cell {
                font-weight: 600;
            }
        }
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>